// import Vue from "vue";
// import Vuetify from "vuetify/lib";
// import theme from './theme'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'

// // This is here just in case you prefer to have all your plugins in a folder like this, otherwise its currently unused

// // Vue.use(Vuetify, {
// //   iconfont: 'mdi',
// //   theme
// // })

// Vue.use(Vuetify);

// export default new Vuetify({
//   icons: {
//     iconfont: 'mdi', // default - only for display purposes
//   }
// });

// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import theme from './theme'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {
    iconfont: 'mdi',
    theme: {
        themes: {
            light: theme
        }
    }
}

export default new Vuetify(opts)
